module.exports = __webpack_public_path__ + "media/login.30b24878.mp4";